// extracted by mini-css-extract-plugin
export default {"select":"mxoDQ","selectDisabled":"F8SM4","item":"Fj9ny","itemActive":"LQbUU","text":"wJ1DH","icon":"UX_h2"};